import { createGlobalState } from 'react-hooks-global-state';

export { functions } from '../firebase.js';

const { setGlobalState, useGlobalState } = createGlobalState({
  siteName: '',
  siteUrl: '',
  email: '',
  firstName: '',
  lastName: '',
  companyName: '',
});

export { useGlobalState, setGlobalState };